import type { PropsWithChildren } from 'react';

import * as GS from '../ProductDetail.styles';

export const DetailsCard = ({ children }: PropsWithChildren) => (
  <GS.DetailsCardCol md={6}>
    <GS.DetailsCard>{children}</GS.DetailsCard>
  </GS.DetailsCardCol>
);
